module.exports = __webpack_public_path__ + "img/spug.a72be899.png";